import { ApiEndpoint } from "./endpoints";
import { dispatchRequest, Method } from "./dispatcher";

export const getBlob = async (
	endpoint: ApiEndpoint,
	id?: string,
	params?: {}
) => {
	const result = await dispatchRequest(
		endpoint,
		Method.GET,
		id,
		null,
		params,
		true
	);

	return result;
};

export const get = async (endpoint: ApiEndpoint, id?: string, params?: {}) => {
	const result = await dispatchRequest(
		endpoint,
		Method.GET,
		id,
		null,
		params
	);

	const { paginationCount, paginationLimit, paginationPage } = result;

	const resultSet = [result.data];

	await new Promise(resolve => {
		if (paginationCount && paginationLimit && paginationPage) {
			const maxPage = Math.ceil(
				Number(paginationCount) / Number(paginationLimit)
			);

			if (maxPage > 1) {
				const loadPage = (page: number) => {
					dispatchRequest(endpoint, Method.GET, null, null, {
						...params,
						page
					}).then(r => {
						resultSet.push(r.data);

						if (page < maxPage) {
							loadPage(page + 1);
						} else {
							resolve();
						}
					});
				};

				loadPage(2);
			} else {
				resolve();
			}
		} else {
			resolve();
		}
	});

	return Promise.all(resultSet);
};

export const getPaginated = async (endpoint: ApiEndpoint, page: number, limit: number) => {
	const result = await dispatchRequest(
		endpoint,
		Method.GET,
		null,
		null,
		{ page, limit }
	);

	return result;
};

export const head = async (endpoint: ApiEndpoint, params?: {}) => {
	const res = await dispatchRequest(
		endpoint,
		Method.HEAD,
		null,
		null,
		params
	);
	return res.data;
};

export const post = async (endpoint: ApiEndpoint, data: {}, params?: {}) => {
	const res = await dispatchRequest(
		endpoint,
		Method.POST,
		null,
		data,
		params
	);
	return res.data;
};

export const put = async (
	endpoint: ApiEndpoint,
	id: string,
	data: {},
	params?: {}
) => {
	const res = await dispatchRequest(endpoint, Method.PUT, id, data, params);
	return res.data;
};

export const patch = async (
	endpoint: ApiEndpoint,
	id: string,
	data: {},
	params?: {}
) => {
	const res = await dispatchRequest(endpoint, Method.PATCH, id, data, params);
	return res.data;
};

export const del = async (endpoint: ApiEndpoint, id: string, params?: {}) => {
	const res = await dispatchRequest(endpoint, Method.DELETE, id, {}, params);
	return res.data;
};
